import React, { useCallback, useState } from 'react';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { useStyles } from './DateSearchBar.styles';
import { startOfMonth } from 'date-fns';
import { DateTimePickerOneMenu } from './../DateTimePickerOne/DateTimePickerOneMenu/DateTimePickerOneMenu.component';
import { useTabNavigationDetails } from '../../Context/TabNavigation.context';
import IconButton from '@material-ui/core/IconButton';
import { useLayoutContext } from '../../Context/Layout.context';
import TooltipOne from '../TooltipOne/TooltipOne.component';

interface DateSearchbarProps {
  onChange: (dateFrom?: Date, dateTo?: Date) => void;
  removeFilter: () => void;
  isActiveFilter?: boolean;
  noBorder?: boolean;
  isTimePicker?: boolean;
  valueFrom?: string;
  valueTo?: string;
}

export const DateSearchbar: React.FC<DateSearchbarProps> = (props) => {
  const classes = useStyles();

  const { highContrastMode } = useLayoutContext();

  const { tabIndexForChildren } = useTabNavigationDetails();

  const [anchorElDateRangeMenu, setAnchorElDateRangeMenu] = useState<SVGSVGElement | HTMLElement | null>(null);
  const [selectedDateFrom, setSelectedDateFrom] = useState<Date | undefined>(
    props.valueFrom ? new Date(props.valueFrom) : undefined,
  );
  const [selectedDateTo, setSelectedDateTo] = useState<Date | undefined>(
    props.valueTo ? new Date(props.valueTo) : undefined,
  );

  const handleChange = (dateFrom?: Date, dateTo?: Date) => {
    props.onChange(dateFrom, dateTo);
    setSelectedDateFrom(dateFrom);
    setSelectedDateTo(dateTo);
  };
  const handleCloseDateRangeMenu = () => {
    setAnchorElDateRangeMenu(null);
    if (selectedDateFrom && selectedDateTo) {
      props.onChange(selectedDateFrom, selectedDateTo);
    }
  };

  const handleRemoveFilter = useCallback(() => {
    setAnchorElDateRangeMenu(null);
    setSelectedDateFrom(undefined);
    setSelectedDateTo(undefined);
    props.removeFilter();
  }, []);

  const handleClickDateRangeSelector = (event: React.MouseEvent<SVGSVGElement | HTMLElement, MouseEvent>) => {
    setAnchorElDateRangeMenu(event.currentTarget);
    if (!selectedDateFrom && !selectedDateTo) {
      setSelectedDateFrom(startOfMonth(new Date()));
      setSelectedDateTo(new Date());
    }
  };

  const activeFilter = props.isActiveFilter ? classes.searchIconActive : '';
  return (
    <div
      className={classes.searchbar}
      style={{
        borderBottom: props.noBorder ? 'none' : '1.5px solid #3C419A',
      }}
    >
      <TooltipOne title="Ustaw datę dla wyszukiwania" placement="top">
        <IconButton
          disableRipple
          aria-label={'ikona wyboru filtru daty i czasu'}
          size="small"
          onClick={handleClickDateRangeSelector}
        >
          <DateRangeIcon
            className={
              highContrastMode
                ? `${classes.searchIcon} ${classes.searchIconContrast} ${activeFilter}`
                : `${classes.searchIcon} ${activeFilter}`
            }
            aria-controls={anchorElDateRangeMenu ? 'date-time-menu' : undefined}
            aria-haspopup="true"
            aria-hidden="false"
            aria-expanded={anchorElDateRangeMenu ? 'true' : undefined}
            tabIndex={tabIndexForChildren}
          />
        </IconButton>
      </TooltipOne>
      {anchorElDateRangeMenu && (
        <DateTimePickerOneMenu
          onChange={handleChange}
          selectedDateFrom={selectedDateFrom}
          selectedDateTo={selectedDateTo}
          noBorder={props.noBorder}
          onClear={handleRemoveFilter}
          pickerAnchor={anchorElDateRangeMenu}
          onClose={handleCloseDateRangeMenu}
          isTimePicker={props.isTimePicker}
        />
      )}
    </div>
  );
};
